module.exports = __webpack_public_path__ + "media/images/peb/20px/peb_a-db297072aaf11df32bfa33b1bb923ad3.png";